import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "reactstrap";
import get from "lodash/get";
import set from "lodash/set";
import groupBy from "lodash/groupBy";
import orderBy from "lodash/orderBy";
import { ShowResourceDetail } from "../../../../form";
import { FONTS } from "../../../../../../constants";
import moment from "../../../../../../lib/moment.js";
import arrow_down from "../../../../../../static/images/arrow-down.svg";
import arrow_up from "../../../../../../static/images/arrow-up.svg";
import Select from "react-select";

const ResourceTable = class extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState;
    if (
      JSON.stringify(get(nextProps, "efficiencyResource")) !==
      JSON.stringify(prevState.efficiencyResource)
    ) {
      const efficiencyResource = get(nextProps, "efficiencyResource");
      const is_submited = get(
        efficiencyResource,
        "efficiencyResource.is_submited"
      );
      const resourceUtilization = is_submited
        ? get(
            efficiencyResource,
            "efficiencyResource.efficiency_resource_snapshot.resourceUtilization",
            []
          )
        : get(efficiencyResource, "resourceUtilization", []);
      const resources = orderBy(
        resourceUtilization,
        [
          (item) => {
            const order = {
              "Full-Time": 1,
              "Part-Time": 2,
              Subcontract: 3,
            };
            return order[item.employee_type];
          },
          "first_name",
          "last_name",
          "nick_name",
        ],
        ["asc", "asc", "asc", "asc"]
      );
      set(tempState, "resourceUtilization", resources);
      set(tempState, "level_list", Object.keys(groupBy(resources, "level")));
      set(tempState, "module_list", Object.keys(groupBy(resources, "module")));
      set(tempState, "items", resources);
      set(
        tempState,
        "efficiencyResource",
        get(nextProps, "efficiencyResource")
      );
    }
    return tempState;
  }

  state = {
    sort_order: true,
    sort_column: 1,
    showDetail: false,
    resourceUtilization: [],
    level_list: [],
    module_list: [],
    filter_level: undefined,
    filter_module: undefined,
    items: [],
  };

  filterResource = (resourceUtilization) => {
    const searchResource = get(this.props, "searchResource").toLowerCase();
    const searchLevel = get(this.state, "filter_level", "").toLowerCase();
    const searchModule = get(this.state, "filter_module", "").toLowerCase();
    return resourceUtilization.filter((res) => {
      const emp_code = get(res, "emp_code").toLowerCase();
      const first_name = get(res, "first_name").toLowerCase();
      const last_name = get(res, "last_name").toLowerCase();
      const nick_name = get(res, "nick_name").toLowerCase();
      const lob_name = get(res, "lob_name").toLowerCase();
      const level = get(res, "level", "").toLowerCase();
      const module = get(res, "module", "").toLowerCase();
      const search = searchResource || searchLevel || searchModule;
      const searchResult = search
        ? (emp_code.includes(searchResource) ||
            first_name.includes(searchResource) ||
            last_name.includes(searchResource) ||
            nick_name.includes(searchResource) ||
            lob_name.includes(searchResource) ||
            level.includes(searchResource)) &&
          (searchLevel ? level === searchLevel : true) &&
          (searchModule ? module === searchModule : true)
        : true;
      return searchResult;
    });
  };

  clickShowDetail = (userID) => {
    this.setState({ userID, showDetail: !this.state.showDetail });
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (JSON.stringify(get(nextProps, 'resourceUtilization')) === JSON.stringify(get(this.props, 'resourceUtilization'))
  //   && JSON.stringify(get(nextState, 'items')) === JSON.stringify(get(this.state, 'items'))
  //   && nextState.sort_column === this.state.sort_column
  //   && nextState.sort_order === this.state.sort_order) return false
  //   return true
  // }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state };
    const { resourceUtilization } = this.state;

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order;
      this.setState({
        sort_order: !this.state.sort_order,
      });
    } else {
      sort_order = false;
      this.setState({
        sort_order: false,
        sort_column: column,
      });
    }
    sort_order = sort_order ? "asc" : "desc";
    const order = ["emp_code", "first_name", "level", "module"];
    const sortColumn = order.find((o) => o === column);
    const list = orderBy(resourceUtilization, sortColumn, sort_order);
    this.setState({ items: list });
  };

  renderHeader = (state) => {
    const efficiencyResource = get(this.props, "efficiencyResource");
    const is_submited = get(
      this.props,
      "efficiencyResource.efficiencyResource.is_submited"
    );
    const resourceUtilization = is_submited
      ? get(
          efficiencyResource,
          "efficiencyResource.efficiency_resource_snapshot.resourceUtilization",
          []
        )
      : get(efficiencyResource, "resourceUtilization", []);
    const resource_util = get(resourceUtilization, ["0", "resource_util"], []);
    let prevYear = "";
    return (
      <HeaderRow noGutters>
        <Col sm={4}>
          <WrapperRow style={{ fontFamily: FONTS.GOTHAM_MEDIUM }}>
            <IDCol>ID</IDCol>
            <NameCol>Name</NameCol>
            <LevelCol
              style={{ cursor: "pointer" }}
              onClick={() => this.handleClickSort("level")}
            >
              Level
              {"level" === state.sort_column &&
                (state.sort_order && "level" === state.sort_column ? (
                  <Icon src={arrow_up} alt="logo" />
                ) : (
                  <Icon src={arrow_down} alt="logo" />
                ))}
            </LevelCol>
            <ModuleCol
              style={{ cursor: "pointer" }}
              onClick={() => this.handleClickSort("module")}
            >
              Module
              {"module" === state.sort_column &&
                (state.sort_order && "module" === state.sort_column ? (
                  <Icon src={arrow_up} alt="logo" />
                ) : (
                  <Icon src={arrow_down} alt="logo" />
                ))}
            </ModuleCol>
          </WrapperRow>
        </Col>
        <Col sm={8}>
          <YearRow style={{ fontFamily: FONTS.GOTHAM_MEDIUM }}>
            {resource_util.map((year) => {
              const notEqual =
                moment(get(year, "month"), "YYYY-MM").year() !== prevYear;
              if (notEqual) {
                prevYear = moment(get(year, "month"), "YYYY-MM").year();
                return (
                  <MonthCol
                    style={{
                      borderLeft: notEqual ? "1px solid #CCCCCC" : "",
                    }}
                  >
                    {moment(get(year, "month"), "YYYY-MM").year()}
                  </MonthCol>
                );
              }
              return <MonthCol />;
            })}
          </YearRow>
          <MonthRow style={{ backgroundColor: "#EDEDED" }}>
            {resource_util.map((month) => {
              return (
                <MonthCol style={{ borderLeft: "1px solid #CCCCCC" }}>
                  {moment(get(month, "month"), "YYYY-MM").format("MMM")}
                </MonthCol>
              );
            })}
          </MonthRow>
        </Col>
      </HeaderRow>
    );
  };

  renderTotalSummary = () => {
    const efficiencyResource = get(this.props, "efficiencyResource");
    const is_submited = get(
      efficiencyResource,
      "efficiencyResource.is_submited"
    );
    const efficiencySummary = is_submited
      ? get(
          efficiencyResource,
          "efficiencyResource.efficiency_resource_snapshot.efficiencySummary",
          []
        )
      : get(efficiencyResource, "efficiencySummary", []);
    return (
      <SummaryRow noGutters style={{ fontFamily: FONTS.GOTHAM_MEDIUM }}>
        <Col sm={4}>
          <TotalText>Total Summary</TotalText>
        </Col>
        <Col sm={8}>
          <MonthRow>
            {efficiencySummary.map((summary) => {
              return (
                <SummaryCol>
                  {parseFloat(get(summary, "efficiency", 0)).toFixed(2)}
                </SummaryCol>
              );
            })}
          </MonthRow>
        </Col>
      </SummaryRow>
    );
  };

  renderResource = (res) => {
    const currentMonth = moment(
      get(this.props, "efficiencyResource.efficiencyResource.month")
    ).month();
    const resource_util = get(res, "resource_util", []);
    const hiring_date = get(res, "hiring_date");
    const last_effective_date = get(res, "last_effective_date");
    return (
      <ResourceRow
        noGutters
        onClick={() => this.clickShowDetail(get(res, "user_id"))}
      >
        <Col sm={4}>
          <WrapperRow style={{ height: 40 }}>
            <IDCol>{get(res, "emp_code", "-")}</IDCol>
            <NameCol>
              <ResourceName>{`${get(res, "first_name")} ${get(
                res,
                "last_name"
              )}`}</ResourceName>
              <span>{` (${get(res, "nick_name")})`}</span>
              <div className="tooltip">{`${get(res, "first_name")} ${get(
                res,
                "last_name"
              )} (${get(res, "nick_name")})`}</div>
            </NameCol>
            <LevelCol>
              <ResourceInfo>{get(res, "level", "-")}</ResourceInfo>
              <div className="tooltip">{get(res, "level", "-")}</div>
            </LevelCol>
            <ModuleCol>
              <ResourceInfo>{get(res, "module", "-")}</ResourceInfo>
              <div className="tooltip">{get(res, "module", "-")}</div>
            </ModuleCol>
          </WrapperRow>
        </Col>
        <Col sm={8}>
          <MonthRow style={{ height: 40 }}>
            {resource_util.map((util, key) => {
              const month = moment(get(util, "month")).month();
              const showBorder =
                month === 3 ||
                month === 6 ||
                month === 9 ||
                month === 0 ||
                key === 0;
              let color;
              if (get(util, "value", 0) > 1) color = "rgba(212, 75, 73, 0.45)";
              else if (
                get(util, "value", 0) < 0.7 &&
                get(util, "value", 0) >= 0
              )
                color = "rgba(240, 173, 78, 0.45)";
              else if (
                get(util, "value", 0) >= 0.7 &&
                get(util, "value", 0) <= 1
              )
                color = "rgba(181, 232, 181, 1)";
              const style = {
                width: "70%",
                height: "50%",
                padding: 1,
                borderRadius: "10px 10px 10px 10px",
                backgroundColor: color,
                textAlign: "center",
              };
              let showWarning = false;
              let warningMessage = "";
              const name = `${get(res, "first_name")} ${get(
                res,
                "last_name"
              )} (${get(res, "nick_name")})`;
              if (last_effective_date === null) {
                showWarning = moment(get(util, "month")).isBefore(
                  moment(hiring_date)
                );
                warningMessage = `${name} hiring date is ${moment(
                  hiring_date
                ).format("DD/MM/YYYY")}`;
              } else {
                showWarning = moment(get(util, "month")).isAfter(
                  moment(last_effective_date).subtract(1, "day")
                );
                warningMessage = `${name} last effective date is ${moment(
                  last_effective_date
                ).format("DD/MM/YYYY")}`;
              }

              return (
                <MonthCol
                  style={{
                    borderLeft: showBorder ? "1px solid #CCCCCC" : "",
                    backgroundColor: month === currentMonth ? "#EDEFF5" : "",
                  }}
                >
                  <WarningWrapper>
                    {showWarning && <Circle />}
                    <span style={color ? style : {}}>
                      {get(util, "value", 0)}
                    </span>
                  </WarningWrapper>
                  {showWarning && (
                    <div className="tooltip" style={{ width: 200 }}>
                      {warningMessage}
                    </div>
                  )}
                </MonthCol>
              );
            })}
          </MonthRow>
        </Col>
      </ResourceRow>
    );
  };

  getOptions = (name) => {
    return this.state[name]
      .filter((l) => l !== "undefined" && l !== "-")
      .map((l) => {
        return { value: l, label: l };
      });
  };

  render() {
    const { resourceUtilization, items } = this.state;
    return (
      <Wrapper fluid>
        {this.state.showDetail && (
          <ShowResourceDetail
            open={this.state.showDetail}
            toggle={() => this.setState({ showDetail: !this.state.showDetail })}
            userID={this.state.userID}
            efficiencyResource={get(this.props, "efficiencyResource")}
          />
        )}
        <Row noGutters>
          <Col sm={4}>
            <WrapperRow
              style={{ fontFamily: FONTS.GOTHAM_MEDIUM, fontSize: "12px" }}
            >
              <div style={{ width: "100%" }}>
                <Select
                  isClearable={true}
                  placeholder="Filter Level"
                  options={this.getOptions("level_list")}
                  onChange={(option) =>
                    this.setState({
                      filter_level: option ? option.value : undefined,
                    })
                  }
                ></Select>
              </div>
              <div style={{ width: "100%" }}>
                <Select
                  isClearable={true}
                  placeholder="Filter Module"
                  options={this.getOptions("module_list")}
                  onChange={(option) =>
                    this.setState({
                      filter_module: option ? option.value : undefined,
                    })
                  }
                ></Select>
              </div>
            </WrapperRow>
          </Col>
          <Col>
            {this.renderHeader(this.state)}
            {this.renderTotalSummary()}
            <BodyTable>
              {this.filterResource(items).map((res) => {
                return this.renderResource(res);
              })}
            </BodyTable>
          </Col>
        </Row>
      </Wrapper>
    );
  }
};

export default ResourceTable;

const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`;

const BodyTable = styled.div`
  background-color: white;
  width: 100%;
  height: calc(100vh - 320px);
  overflow-y: overlay;
  overflow-x: hidden;
  position: relative;
`;
const Wrapper = styled(Container)`
  position: relative;
  padding: 10px;
  margin: 0px;
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM};

  .tooltip {
    width: 50%;
    max-width: 200px;
    font-size: 12px;
    top: 30px;
    background-color: #fff;
    padding: 5px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
    transition: opacity 1s ease;
    opacity: 0;
    visibility: hidden;
  }

  span:hover + .tooltip,
  .tooltip:hover,
  span:hover ~ span + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 1s;
    opacity: 1;
    visibility: visible;
  }
  p:hover + .tooltip,
  .tooltip:hover {
    transition: opacity 0s ease;
    transition-delay: 0s;
    opacity: 1;
    visibility: visible;
  }
`;
const WrapperRow = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  border-bottom: 1px solid #cccccc;
`;
const HeaderRow = styled(Row)`
  height: 50px;
  background-color: #404040;
  color: white;
  cursor: default;
`;
const SummaryRow = styled(Row)`
  height: 25px;
  background-color: #cccccc;
  cursor: default;
`;
const MonthRow = styled(WrapperRow)`
  height: 25px;
  color: black;
  justify-content: space-around;
  align-items: center;
`;
const SummaryCol = styled(MonthRow)`
  background-color: #cccccc;
  border-left: 1px solid rgba(0, 0, 0, 0.16);
`;
const YearRow = styled(MonthRow)`
  background-color: white;
`;
const IDCol = styled.div`
  height: 100%;
  width: 62px;
  max-width: 62px;
  min-width: 62px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
`;
const NameCol = styled.div`
  height: 100%;
  width: 170px;
  max-width: 170px;
  min-width: 170px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 5px;
`;
const InfoCol = styled.div`
  height: 100%;
  width: 15%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;
const LevelCol = styled(InfoCol)`
  width: 25%;
  padding-left: 0px;
  padding-right: 0px;
`;
const ModuleCol = styled(InfoCol)`
  width: 25%;
  padding-left: 0px;
  padding-right: 0px;
`;
const MonthCol = styled.div`
  height: 100%;
  width: 100px;
  max-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;
const TotalText = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 10px;
`;
const ResourceName = styled.span`
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
`;
const ResourceInfo = styled(ResourceName)`
  width: 80%;
`;
const ResourceRow = styled(Row)`
  cursor: pointer;
  :hover {
    background-color: #e5e5e5;
  }
`;
const Circle = styled.span`
  font-size: 10px;
  text-align: center;
  height: 10px;
  width: 10px;
  background-color: #d44b49;
  border-radius: 50%;
  cursor: default;
  position: absolute;
  top: 12%;
  right: 12%;
  cursor: pointer;
  z-index: 1;
`;
const WarningWrapper = styled.p`
  font-family: ${FONTS.GOTHAM} !important;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/detail/tab-content/resource-table.js